// import QueryString from "qs";
import dynamic from "next/dynamic";
import React from "react";
const GhostPageDetails = dynamic(() => import("./Details"),{ssr: true});
const HocHead = dynamic(() => import("@/Components/HigherOrderComponent/HocHead"),{ssr: true});

const GhostPage = (props: any) => {
  const sdata = props.data;
  // const data = sdata.data[0].attributes;
  const seo = sdata.data[0].attributes.seo;
  const blocks = sdata.data[0].attributes.blocks;

  return (
    <>
      {seo && <HocHead seo={seo} />}
      <GhostPageDetails blocks={blocks} />
    </>
  );
};

export default GhostPage;
